export default __webpack_public_path__ + "static/media/bukola.557c8466.jpg";